import Api from "../api/api";
import * as types from "./mutation-types";

// 获取导航列表 分页
export const menuListNoPagination = ({commit}, params) => {
  console.log(commit, params, 'params=====');
  return Api.menuListNoPagination(params).then(res => {
    if (res.success) {
      if (params.level === 1) {
        commit(types.firstMenuMutation, res.data);
        const firstMenuMap = {};
        res.data.map(item => {
          firstMenuMap[item.id] =  item;
        });
        commit(types.firstMenuMapMutation, firstMenuMap);
      } else if (params.level === 2) {
        commit(types.secondMenuMutation, res.data);
        const secondMenuMap = {};
        res.data.map(item => {
          secondMenuMap[item.id] =  item;
        });
        commit(types.secondMenuMapMutation, secondMenuMap);
      } else if (params.level === 3) {
        commit(types.thirdMenuMutation, res.data);
        const thirdMenuMap = {};
        res.data.map(item => {
          thirdMenuMap[item.id] =  item;
        });
        commit(types.thirdMenuMapMutation, thirdMenuMap);
      }
      // commit(types.menuListDataMutation, res.data);
    }
    return res;
  }).catch(err => {
    console.log(err);
  });
};

  // 导航id 获取内容
export const menuIdContent = ({commit}, params) => {
  console.log(commit, params, 'params=====');
  return Api.menuIdContent(params).then(res => {
    return res;
  }).catch(err => {
    console.log(err);
  });
};


 // menuid 获取内容
export const getRichTextContent = ({commit}, params) => {
  console.log(commit, params, 'params=====');
  return Api.getRichTextContent(params).then(res => {
    return res;
  }).catch(err => {
    console.log(err);
  });
};

// menuid 获取内容 分页
export const getRichTextContentPage = ({commit}, params) => {
  console.log(commit, params, 'params=====');
  return Api.getRichTextContentPage(params).then(res => {
    return res;
  }).catch(err => {
    console.log(err);
  });
};